// extracted by mini-css-extract-plugin
module.exports = {"layoutMain":"Basic_layoutMain__185ho","layoutContent":"Basic_layoutContent__13SwH"};